module.exports = __webpack_public_path__ + "static/media/logo1.80a1b3cc.png";